import { SubmissionError, reset } from 'redux-form';
import { all, call, put, takeEvery } from 'redux-saga/effects'

import Api from '../../Api'
import { combineReducers } from "redux";
import createTableFetcher from 'common/reducer/createTableFetcher'

// ES6

const getFetcher = state => {
    return state.waas.serviceStatus.serviceStatus
}
export const fetcher = createTableFetcher('applications', Api.fetchApplications, getFetcher)

export const types = {
    SET_IS_LOADING: 'APPLICATIONS_TABLE/SET_IS_LOADING',
    TOGGLE_APP_MODE: 'APPLICATIONS_TABLE/TOGGLE_APP_MODE',
    TOGGLE_DELETE_DIALOG: 'APPLICATIONS_TABLE/TOGGLE_DELETE_DIALOG',
    DELETE_APP: 'APPLICATIONS_TABLE/DELETE',
    TOGGLE_RENAME_DIALOG: 'APPLICATIONS_TABLE/TOGGLE_RENAME_DIALOG',
    RENAME_APP: 'APPLICATIONS_TABLE/RENAME_APP',
}

export const actions = {
    toggleAppMode: (id, currentValue) => ({ type: types.TOGGLE_APP_MODE, id, currentValue }),
    deleteApp: (id) => ({ type: types.DELETE_APP, id }),
    setIsLoading: (isLoading) => ({ type: types.SET_IS_LOADING, isLoading }),
    toggleDeleteDialog: (id, name) => ({ type: types.TOGGLE_DELETE_DIALOG, id, name }),
    toggleRenameDialog: (id = undefined, name = '') => ({ type: types.TOGGLE_RENAME_DIALOG, id, name }),
    renameApp: (id, data, reject, resolve) => ({ type: types.RENAME_APP, id, data, reject, resolve }),    
}

export const initialState = {
    isLoading: false,
    items: [
        {
            address: '3333',
            status: 'UP'
        },
        {
            address: '1111',
            status: 'DOWN'
        },
    ]
}

const serviceStatus = (state = initialState, action) => {
    switch (action.type) {
        case types.SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case types.TOGGLE_DELETE_DIALOG:
            return {
                ...state,
                deleteDialogOpen: !state.deleteDialogOpen,
                deleteID: action.id,
                deleteName: action.name
            };
        case types.TOGGLE_RENAME_DIALOG:
            return {
                ...state,
                renameDialogOpen: !state.renameDialogOpen,
                renameID: action.id,
                renameName: action.name
            };
        default:
            return state;
    }
}

export default combineReducers({
    serviceStatus,
    fetcher: fetcher.reducer
});

export function* toggleAppMode(action) {
    yield put(actions.setIsLoading(true));
    const protection_mode = action.currentValue === 'Active' ? 'Passive' : 'Active';

    try {
        yield call(Api.updateAppMode, action.id, { protection_mode: protection_mode })
        yield put(fetcher.actions.trigger());
    }
    catch (e) {
    }
    finally {
        yield put(actions.setIsLoading(false));
    }
}

export function* deleteApp(action) {
    yield put(actions.toggleDeleteDialog());
    yield put(actions.setIsLoading(true));
    try {
        yield call(Api.deleteApp, action.id);
        yield put(fetcher.actions.trigger());
    }
    catch (e) {
    }
    finally {
        yield put(actions.setIsLoading(false));
    }
}

export function* renameApp(action) {
    try {
        yield call(Api.renameApp, action.id, action.data);
        yield put(fetcher.actions.trigger());
        yield put(actions.toggleRenameDialog());
        yield call(action.resolve);
        yield put(reset('renameAppDialog'));
    } catch (e) {
        if (e.response !== undefined) {
            let errors = e.response.data;            
            yield call(action.reject, new SubmissionError(errors));
        } else {
            yield call(action.reject);
        }
    }
}


export function* applicationTableFlow() {
    yield takeEvery(types.DELETE_APP, deleteApp);
    yield takeEvery(types.TOGGLE_APP_MODE, toggleAppMode);
    yield takeEvery(types.RENAME_APP , renameApp);
}

export function* serviceStatusSaga() {
    yield all([
        // fetcher.saga(),
        applicationTableFlow(),
    ])
}